<template>
    <div>
        <el-dialog :title="deviceName+'设备(编号：'+deviceCode+')下发历史指令'" :visible.sync="gdetails" width="35%" center>
            <div>
                <el-date-picker v-model="onlineTime" type="datetimerange" :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="getOnlineDetailData">
                </el-date-picker>
                <el-button type="primary" @click="getProtocolList">搜索</el-button>
            </div>
            <el-table :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" style="width: 100%">
                <el-table-column prop="cmd" label="指令" width="180" />
                <el-table-column prop="status" label="状态" width="">
                    <template slot-scope="scope">
                        <span>{{scope.row.status==1?'成功':scope.row.status==0?'失败':''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormat" label="创建时间">
                </el-table-column>
            </el-table>
            <el-pagination layout="prev, pager, next" :total="total" :current-page.sync="currentPage" :page-size="10" @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
            <span style="margin-left: 45%;">
                <el-button @click="gdetails=false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import API from "../../api/api";
import dayjs from "dayjs";
export default {
    data() {
        return {
            gdetails: false,
            tableData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1,
            onlineTime: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()],
            pickerOptions: { //时间选择器
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }],

            },
            deviceName: '',
            deviceCode: '',
        }
    },
    methods: {
        show(data) {
            console.log(data)
            this.code = data.code
            this.deviceCode = data.code;
            this.deviceName = data.name;
            console.log(this.ids)
            this.gdetails = true
            this.getProtocolList()
        },
        //查询设备协议下拉数据
        getProtocolList() {
            let param = {
                mduCode: this.code,
                startDate: dayjs(this.onlineTime[0]).format("YYYY-MM-DD HH:mm:ss"),
                endDate: dayjs(this.onlineTime[1]).format("YYYY-MM-DD HH:mm:ss"),
            };
            API.platformAutoCmde(param).then(res => {
                if (res.code == 1) {
                    this.tableData = res.data;
                    this.total = this.tableData.length
                    //   console.log(this.total)
                }
            });
        },
        getOnlineDetailData() {
            this.getProtocolList()
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        dateFormat(row, column, cellValue, index) {
            //   console.log(column)
            if (row[column.property]) {
                return dayjs(new Date(row[column.property])).format("YYYY-MM-DD HH:mm:ss")
            } else {
                return '--'
            }
        },
    }
}
</script>
<style scoped>
dd {
    margin-left: 90%;
}
</style>


// WEBPACK FOOTER //
// src/views/platform/automaticGateway.vue